import { colors } from './colors';
import { ExtendedTheme } from './themes';

export const lightPalette: ExtendedTheme = {
  palette: {
    mode: 'light',
    success: {
      main: '#85e0ba',
      dark: '#2d8376',
      light: '#EAFBF1',
    },
    info: {
      main: '#297ceb',
      dark: '#256faf',
      light: '#3BABFF',
    },
    error: {
      main: `#e5484d`,
      dark: `#f3b0a2`,
      light: `#fff0ee`,
      hoverBg: '#fdd8d3',
      hoverBorder: '#e54d2e',
    },
    warning: {
      main: '#dc7b18',
      dark: '#ffe3a2',
      light: '#fefbf5',
    },
    primary: {
      main: `#72ADE3`, //main color for button
      light: `#1690B6BF`, // button border
      dark: '#09507c', // border on hover
      contrastText: '#3f8ecfcc', // bg on hover
    },
    secondary: {
      main: '#3babff',
      dark: '#76a7dc',
    },
    background: {
      default: '#FFFFFF',
      paper: '#fcfcfc',
    },
    common: {
      black: '#ffffff',
      white: `${colors.foreground}`,
    },

    text: {
      primary: `${colors.black}`,
      secondary: `${colors.lightIcons}`,
      disabled: '#898989',
    },
    divider: `${colors.lightBorder}`,
    action: {
      hover: `${colors.lightIconHover}`,
      disabledBackground: `${colors.foreground}`,
    },
  },
};
